import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import Login from '../../pages/auth/login/Login'

const AuthRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
    )
}

export default AuthRoutes